import React from 'react';

function Bolivia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124181)">
        <mask
          id="mask0_800_124181"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124181)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#FECA00"
          />
          <mask
            id="mask1_800_124181"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124181)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#DB501C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#5EAA22"
            />
            <path
              d="M14.002 9.95908L14.0428 9.92383L22.1649 16.8686L22.124 16.9038L14.002 9.95908Z"
              fill="#864C26"
            />
            <path
              d="M22.7487 16.4173L22.7137 16.4569L13.2646 10.2874L13.2997 10.2478L22.7487 16.4173Z"
              fill="#864C26"
            />
            <path
              d="M22.948 15.8017L22.9195 15.845L12.4087 10.7595L12.4371 10.7161L22.948 15.8017Z"
              fill="#A05A2C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.052 9.11224L13.848 9.58032L13.8035 9.6073C13.8217 9.61658 13.8404 9.62653 13.8597 9.63715C13.8821 9.64947 13.8978 9.66434 13.907 9.68142C13.9232 9.63915 13.9228 9.58783 13.9056 9.52664L13.8637 9.3776L13.9581 9.50824C14.1081 9.71583 14.1304 9.86436 14.0138 9.9484C13.8998 10.0305 13.7205 10.0091 13.4782 9.89075L13.3798 9.84266L13.4921 9.84417C13.5843 9.84541 13.6634 9.83574 13.7296 9.81535L13.6837 9.80442C13.6448 9.79515 13.616 9.77092 13.5964 9.73296L13.5184 9.7803L13.052 9.11224ZM12.0975 9.6413L12.9728 9.9794L12.9332 10.0137C12.9537 10.0203 12.9749 10.0274 12.9969 10.0352C13.0213 10.0439 13.0397 10.0562 13.0522 10.0716C13.0597 10.0275 13.0492 9.97713 13.0204 9.91964L12.9501 9.77933L13.0686 9.89341C13.2568 10.0747 13.3079 10.2175 13.2094 10.3183C13.1132 10.4167 12.9324 10.4233 12.6707 10.3442L12.5643 10.312L12.6752 10.2962C12.7666 10.2831 12.8428 10.2613 12.9041 10.2309L12.8562 10.2271C12.8154 10.224 12.7819 10.2039 12.7549 10.1685L12.6872 10.2272L12.0975 9.6413ZM12.1551 10.4531L11.25 10.1841L11.895 10.7221L11.9565 10.6585C11.987 10.6922 12.0226 10.7099 12.0639 10.7099H12.112C12.0539 10.745 11.9801 10.7727 11.8903 10.7928L11.7813 10.8171L11.8904 10.8409C12.1589 10.8995 12.3383 10.8789 12.4245 10.7734C12.5127 10.6654 12.4479 10.5271 12.2426 10.3611L12.1134 10.2566L12.1972 10.3909C12.2315 10.4459 12.2468 10.4952 12.2437 10.5396C12.2298 10.5252 12.2104 10.5145 12.1852 10.5078C12.1621 10.5016 12.1399 10.496 12.1185 10.491L12.1551 10.4531ZM12.0562 10.4776L12.0572 10.4766L11.4773 10.3043L11.8905 10.6489L11.9245 10.6138C11.9184 10.6033 11.9125 10.5921 11.907 10.58L11.9108 10.5787L11.8832 10.5523L11.9941 10.4669L12.0081 10.4691C12.0235 10.4715 12.0396 10.4743 12.0562 10.4776Z"
              fill="#E7E7E7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.1553 16.2132L16.0943 14.7244L17.4116 15.0397L16.4636 16.3985H16.0943V16.5467L15.1553 16.2132Z"
              fill="#925229"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.7525 10.4886L14.1309 11.0628L13.9048 14.857L16.1445 15.1472C16.1445 15.1472 15.1685 14.3855 15.0246 13.9155C14.8808 13.4454 14.8349 11.6906 15.107 11.4238L15.3196 11.5341L15.4906 11.0826"
              fill="#FFE000"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5879 10.7474C12.5879 10.7474 12.3472 13.71 12.3472 14.2304C12.3472 14.7507 12.8441 15.9897 13.977 15.9897C15.1099 15.9897 16.6644 15.4353 16.6644 15.2092C16.6644 14.9832 16.2003 14.8212 16.2003 14.8212C16.2003 14.8212 14.1169 14.9478 14.1169 14.2304C14.1169 13.5129 14.2584 11.3892 14.3821 11.1388C14.5058 10.8884 14.9345 10.5108 14.9345 10.5108L14.1169 9.9707L13.977 10.5108L13.4528 10.3522L13.2928 11.1388L12.5879 10.7474Z"
              fill="#D52C1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.4988 11.0761L15.3482 11.4951L15.0439 11.381C15.0439 11.381 14.589 13.2772 15.0439 14.0715C15.4988 14.8659 16.6444 14.9235 16.6444 14.9235L16.1604 11.4951L15.4988 11.0761Z"
              fill="#027934"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.4319 13.6382L14.3401 14.4057C14.3401 14.4057 14.0407 14.7872 14.3401 15.076C14.6396 15.3648 15.4698 15.6593 15.6656 15.3107C15.8615 14.962 16.4434 14.5537 16.4434 14.5537L15.4319 13.6382Z"
              fill="#E8A30C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.2886 10.7425C16.5543 10.5372 16.6874 10.2868 16.586 10.1831C16.4846 10.0794 16.1871 10.1618 15.9214 10.367C15.6558 10.5723 15.5226 10.8228 15.624 10.9264C15.7254 11.0301 16.023 10.9478 16.2886 10.7425Z"
              fill="#E1E5E8"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.6186 9.30331C15.6186 9.30331 15.5117 9.28385 15.4633 9.27733C15.118 9.2308 14.9453 9.2934 14.9453 9.46512C14.9453 9.75879 15.1654 10.0759 15.1654 10.2977C15.1654 10.5195 15.1761 10.8648 15.282 10.6922C15.3878 10.5195 15.9263 10.0007 15.9263 10.0007L15.6186 9.55058C15.6186 9.55058 16.3823 9.62693 16.047 9.46512"
              fill="#D52C1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.9657 15.3782L17.393 15.3731C16.9678 15.7468 16.9286 16.2497 17.2634 16.857C17.2634 16.857 17.3732 16.9982 17.4117 16.985C17.4656 16.9665 17.5404 16.762 17.5404 16.762C17.5149 16.169 17.9402 15.7762 17.9657 15.3782Z"
              fill="#D52C1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.2406 15.3936L17.4466 15.3085C17.6495 15.6833 17.5478 16.0714 17.1562 16.4569L16.9858 16.3248C17.1562 15.8827 17.1562 15.6995 17.2406 15.3936Z"
              fill="#FFE000"
            />
            <path
              d="M16.9773 15.3816L17.1922 15.3257C17.2955 15.6396 17.2439 15.9634 17.041 16.292L16.8447 16.1963C17.0202 15.9122 17.0632 15.6424 16.9773 15.3816Z"
              fill="#027934"
            />
            <path
              d="M21.998 9.95908L21.9572 9.92383L13.8351 16.8686L13.876 16.9038L21.998 9.95908Z"
              fill="#864C26"
            />
            <path
              d="M13.2513 16.4173L13.2863 16.4569L22.7354 10.2874L22.7003 10.2478L13.2513 16.4173Z"
              fill="#864C26"
            />
            <path
              d="M13.052 15.8017L13.0805 15.845L23.5913 10.7595L23.5629 10.7161L13.052 15.8017Z"
              fill="#A05A2C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.948 9.11224L22.152 9.58032L22.1965 9.6073C22.1783 9.61658 22.1596 9.62653 22.1403 9.63715C22.1179 9.64947 22.1022 9.66434 22.093 9.68142C22.0768 9.63915 22.0772 9.58783 22.0944 9.52664L22.1363 9.3776L22.0419 9.50824C21.8919 9.71583 21.8696 9.86436 21.9862 9.9484C22.1002 10.0305 22.2795 10.0091 22.5218 9.89075L22.6202 9.84266L22.5079 9.84417C22.4157 9.84541 22.3366 9.83574 22.2704 9.81535L22.3163 9.80442C22.3552 9.79515 22.384 9.77092 22.4036 9.73296L22.4816 9.7803L22.948 9.11224ZM23.9025 9.6413L23.0272 9.9794L23.0668 10.0137C23.0463 10.0203 23.0251 10.0274 23.0031 10.0352C22.9787 10.0439 22.9603 10.0562 22.9478 10.0716C22.9403 10.0275 22.9508 9.97713 22.9796 9.91964L23.0499 9.77933L22.9314 9.89341C22.7432 10.0747 22.6921 10.2175 22.7906 10.3183C22.8868 10.4167 23.0676 10.4233 23.3293 10.3442L23.4357 10.312L23.3248 10.2962C23.2334 10.2831 23.1572 10.2613 23.0959 10.2309L23.1438 10.2271C23.1846 10.224 23.2181 10.2039 23.2451 10.1685L23.3128 10.2272L23.9025 9.6413ZM23.8449 10.4531L24.75 10.1841L24.105 10.7221L24.0435 10.6585C24.013 10.6922 23.9774 10.7099 23.9361 10.7099H23.888C23.9461 10.745 24.0199 10.7727 24.1097 10.7928L24.2187 10.8171L24.1096 10.8409C23.8411 10.8995 23.6617 10.8789 23.5755 10.7734C23.4873 10.6654 23.5521 10.5271 23.7574 10.3611L23.8866 10.2566L23.8028 10.3909C23.7685 10.4459 23.7532 10.4952 23.7563 10.5396C23.7702 10.5252 23.7896 10.5145 23.8148 10.5078C23.8379 10.5016 23.8601 10.496 23.8815 10.491L23.8449 10.4531ZM23.9438 10.4776L23.9428 10.4766L24.5227 10.3043L24.1095 10.6489L24.0755 10.6138C24.0816 10.6033 24.0875 10.5921 24.093 10.58L24.0892 10.5787L24.1168 10.5523L24.0059 10.4669L23.9919 10.4691C23.9765 10.4715 23.9604 10.4743 23.9438 10.4776Z"
              fill="#E7E7E7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.8447 16.2132L19.9057 14.7244L18.5884 15.0397L19.5364 16.3985H19.9057V16.5467L20.8447 16.2132Z"
              fill="#925229"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.2475 10.4886L21.8691 11.0628L22.0952 14.857L19.8555 15.1472C19.8555 15.1472 20.8315 14.3855 20.9754 13.9155C21.1192 13.4454 21.1651 11.6906 20.893 11.4238L20.6804 11.5341L20.5094 11.0826"
              fill="#FFE000"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.4121 10.7474C23.4121 10.7474 23.6528 13.71 23.6528 14.2304C23.6528 14.7507 23.1559 15.9897 22.023 15.9897C20.8901 15.9897 19.3356 15.4353 19.3356 15.2092C19.3356 14.9832 19.7997 14.8212 19.7997 14.8212C19.7997 14.8212 21.8831 14.9478 21.8831 14.2304C21.8831 13.5129 21.7416 11.3892 21.6179 11.1388C21.4942 10.8884 21.0655 10.5108 21.0655 10.5108L21.8831 9.9707L22.023 10.5108L22.5472 10.3522L22.7072 11.1388L23.4121 10.7474Z"
              fill="#D52C1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5012 11.0762L20.6518 11.4952L20.9561 11.3811C20.9561 11.3811 21.411 13.2773 20.9561 14.0716C20.5012 14.8659 19.3556 14.9236 19.3556 14.9236L19.8396 11.4952L20.5012 11.0762Z"
              fill="#027934"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5681 13.6382L21.6599 14.4057C21.6599 14.4057 21.9593 14.7872 21.6599 15.076C21.3604 15.3648 20.5302 15.6593 20.3344 15.3107C20.1385 14.962 19.5566 14.5537 19.5566 14.5537L20.5681 13.6382Z"
              fill="#E8A30C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.7114 10.7425C19.4457 10.5372 19.3126 10.2868 19.414 10.1831C19.5154 10.0794 19.8129 10.1618 20.0786 10.367C20.3442 10.5723 20.4774 10.8228 20.376 10.9264C20.2746 11.0301 19.977 10.9478 19.7114 10.7425Z"
              fill="#E1E5E8"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0343 15.3782L18.607 15.3731C19.0322 15.7468 19.0714 16.2497 18.7366 16.857C18.7366 16.857 18.6268 16.9982 18.5883 16.985C18.5344 16.9665 18.4596 16.762 18.4596 16.762C18.4851 16.169 18.0598 15.7762 18.0343 15.3782Z"
              fill="#D52C1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.7594 15.3936L18.5534 15.3085C18.3505 15.6833 18.4522 16.0714 18.8438 16.4569L19.0142 16.3248C18.8438 15.8827 18.8438 15.6995 18.7594 15.3936Z"
              fill="#FFE000"
            />
            <path
              d="M19.0227 15.3816L18.8078 15.3257C18.7045 15.6396 18.7561 15.9634 18.959 16.292L19.1553 16.1963C18.9798 15.9122 18.9368 15.6424 19.0227 15.3816Z"
              fill="#027934"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.2476 12.8209C15.2476 14.2601 16.4431 15.4577 17.9707 15.4577C19.4984 15.4577 20.6939 14.2601 20.6939 12.8209C20.6939 11.3817 19.4984 10.1841 17.9707 10.1841C16.4431 10.1841 15.2476 11.3817 15.2476 12.8209ZM20.0566 12.8209C20.0566 13.9749 19.1227 14.9104 17.9707 14.9104C16.8187 14.9104 15.8849 13.9749 15.8849 12.8209C15.8849 11.6668 16.8187 10.7313 17.9707 10.7313C19.1227 10.7313 20.0566 11.6668 20.0566 12.8209Z"
              fill="#00A6DE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.9706 14.9104C19.1226 14.9104 20.0564 13.9749 20.0564 12.8209C20.0564 11.6668 19.1226 10.7313 17.9706 10.7313C16.8186 10.7313 15.8848 11.6668 15.8848 12.8209C15.8848 13.9749 16.8186 14.9104 17.9706 14.9104Z"
              fill="#FFC036"
            />
            <mask
              id="mask2_800_124181"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="15"
              y="10"
              width="6"
              height="5"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.9706 14.9104C19.1226 14.9104 20.0564 13.9749 20.0564 12.8209C20.0564 11.6668 19.1226 10.7313 17.9706 10.7313C16.8186 10.7313 15.8848 11.6668 15.8848 12.8209C15.8848 13.9749 16.8186 14.9104 17.9706 14.9104Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124181)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.9706 12.4477L17.6999 12.9439L17.7067 12.396L17.212 12.7422L17.495 12.251L16.8744 12.3786L17.3775 12.0416L16.7539 11.9253L17.3775 11.8091L16.8744 11.472L17.495 11.5996L17.212 11.1085L17.7067 11.4547L17.6999 10.9067L17.9706 11.4029L18.2414 10.9067L18.2346 11.4547L18.7293 11.1085L18.4463 11.5996L19.0669 11.472L18.5638 11.8091L19.1874 11.9253L18.5638 12.0416L19.0669 12.3786L18.4463 12.251L18.7293 12.7422L18.2346 12.396L18.2414 12.9439L17.9706 12.4477Z"
                fill="#D52C1E"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7958 12.9411C15.7958 12.9411 17.427 11.9201 17.8278 11.9201C18.2285 11.9201 19.9379 12.9466 20.2876 13.0863C20.6374 13.2259 20.2876 15.9642 20.2876 15.9642H15.6606L15.7958 12.9411Z"
                fill="#027934"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.784 11.7258L15.8846 11.7753C16.4342 10.9508 17.1335 10.5419 17.9865 10.5419C18.9415 10.5891 19.6567 11.0525 20.1342 11.9384L20.2393 11.8966C19.7448 10.9789 18.9932 10.492 17.9898 10.4424C17.0883 10.4424 16.3529 10.8724 15.784 11.7258ZM15.3789 13.3159L15.5663 13.204L15.7536 13.3159L15.6875 13.1284L15.8693 13.01L15.6412 13.006L15.5663 12.8209L15.4913 13.006L15.2632 13.01L15.445 13.1284L15.3789 13.3159ZM15.7981 13.9503L15.6108 14.0622L15.6768 13.8747L15.495 13.7563L15.7231 13.7523L15.7981 13.5672L15.873 13.7523L16.1011 13.7563L15.9193 13.8747L15.9854 14.0622L15.7981 13.9503ZM16.0742 14.6592L16.2616 14.5473L16.4489 14.6592L16.3828 14.4716L16.5646 14.3533L16.3365 14.3493L16.2616 14.1642L16.1866 14.3493L15.9585 14.3533L16.1403 14.4716L16.0742 14.6592ZM16.9569 15.0448L16.7695 15.1567L16.8356 14.9692L16.6538 14.8508L16.8819 14.8468L16.9569 14.6617L17.0318 14.8468L17.2599 14.8508L17.0781 14.9692L17.1442 15.1567L16.9569 15.0448ZM17.7546 15.4055L17.9419 15.2935L18.1292 15.4055L18.0631 15.2179L18.245 15.0995L18.0168 15.0955L17.9419 14.9105L17.867 15.0955L17.6388 15.0995L17.8207 15.2179L17.7546 15.4055ZM20.3754 13.204L20.5627 13.3159L20.4966 13.1284L20.6785 13.01L20.4503 13.006L20.3754 12.8209L20.3005 13.006L20.0723 13.01L20.2542 13.1284L20.1881 13.3159L20.3754 13.204ZM20.3309 14.0622L20.1436 13.9503L19.9563 14.0622L20.0223 13.8747L19.8405 13.7563L20.0687 13.7523L20.1436 13.5672L20.2185 13.7523L20.4467 13.7563L20.2648 13.8747L20.3309 14.0622ZM19.6801 14.5473L19.8674 14.6592L19.8013 14.4716L19.9832 14.3533L19.755 14.3493L19.6801 14.1642L19.6052 14.3493L19.377 14.3533L19.5589 14.4716L19.4928 14.6592L19.6801 14.5473ZM19.1721 15.1567L18.9848 15.0448L18.7975 15.1567L18.8636 14.9692L18.6817 14.8508L18.9099 14.8468L18.9848 14.6617L19.0597 14.8468L19.2879 14.8508L19.106 14.9692L19.1721 15.1567Z"
              fill="#FFC036"
            />
            <path
              d="M16.5189 7.00702L16.7424 7.15164C16.1693 7.60873 16.0616 8.11845 16.1714 8.55634C16.2857 9.01255 16.7939 9.49919 17.7178 9.99892L17.3781 10.462C16.3231 9.89134 15.7155 9.36332 15.5579 8.7345C15.3957 8.08737 15.7939 7.58523 16.5189 7.00702Z"
              fill="#036A2D"
            />
            <path
              d="M19.5598 7.00702L19.3362 7.15164C19.9093 7.60873 20.017 8.11845 19.9073 8.55634C19.7929 9.01255 19.2847 9.49919 18.3608 9.99892L18.7005 10.462C19.7555 9.89134 20.3631 9.36332 20.5207 8.7345C20.6829 8.08737 20.2848 7.58523 19.5598 7.00702Z"
              fill="#036A2D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.372 8.86155C14.372 8.86155 15.3501 8.26042 15.8142 8.26042C16.2783 8.26042 16.8978 8.12273 16.9949 8.43899C17.092 8.75526 17.2756 8.66366 17.635 8.66366C17.9945 8.66366 18.7009 8.66366 18.7009 8.66366C18.7009 8.66366 18.4899 8.26042 18.8809 8.26042C19.2718 8.26042 20.9047 8.46578 21.3976 8.66366C21.8905 8.86155 21.9152 8.97853 21.9152 8.97853C21.9152 8.97853 21.4591 8.74457 20.9545 8.86155C20.4499 8.97853 19.5347 9.49359 19.1178 9.49359C18.7009 9.49359 18.3672 9.89173 18.3672 9.89173C18.3672 9.89173 18.3947 9.68765 18.0149 9.78969C17.635 9.89173 17.6439 10.3724 17.3194 10.2842C16.9949 10.1959 17.4129 9.49359 17.3194 9.49359C17.2259 9.49359 16.5633 9.26275 16.5633 9.26275C16.5633 9.26275 15.9204 8.74457 14.9657 8.86155C14.011 8.97853 14.372 8.86155 14.372 8.86155Z"
              fill="#452C24"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.855 9.2886C18.047 9.2886 18.2026 9.16609 18.2026 9.01496C18.2026 8.86384 18.047 8.74133 17.855 8.74133C17.663 8.74133 17.5073 8.86384 17.5073 9.01496C17.5073 9.16609 17.663 9.2886 17.855 9.2886Z"
              fill="#E7E7E7"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.104 9.00719C17.104 9.00719 17.2164 8.81824 17.4392 8.81824C17.662 8.81824 18.0798 8.81824 18.0798 8.91272C18.0798 9.00719 18.1133 9.13061 17.7763 9.13061C17.4392 9.13061 17.6552 9.00719 17.4392 9.00719C17.2233 9.00719 17.104 9.00719 17.104 9.00719Z"
              fill="#E8A30C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.0783 10.2834C21.2079 10.1628 21.2802 9.87043 21.2802 9.87043C21.2802 9.87043 20.7018 9.95273 20.5671 9.87043C20.4325 9.78813 20.3626 9.54694 20.3626 9.54694C20.3626 9.54694 19.8415 9.75861 20.0402 9.75861C20.239 9.75861 20.3626 9.91516 20.3626 9.91516L20.767 10.0476C20.767 10.0476 20.4985 10.2834 20.6328 10.2834C20.767 10.2834 20.9488 10.404 21.0783 10.2834Z"
              fill="#E1E5E8"
            />
            <path
              d="M20.0596 10.3838L19.9868 10.3065L20.495 9.95294L20.5678 10.0303L20.0596 10.3838Z"
              fill="#925229"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124181">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Bolivia;
